"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _ArrowRight = _interopRequireDefault(require("@material-ui/icons/ArrowRight"));
var _clsx = _interopRequireDefault(require("clsx"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
/**
 * Creates a simple tabbed table to display the matched case IDs
 * for an uploaded file.
 *
 * @param {object} props
 * @param {object} props.classes - Material UI styles
 * @param {array} props.matched - Array of matched case IDs
 * @param {array} props.unmatched - Array of unmatched case IDs
 * @param {string|null} props.error - Error message to display
 * @returns {JSX.Element}
 */
var SummaryTable = function SummaryTable(props) {
  var classes = props.classes,
    matched = props.matched,
    unmatched = props.unmatched,
    _props$error = props.error,
    error = _props$error === void 0 ? null : _props$error;
  var _ref = (0, _react.useState)('matched'),
    _ref2 = _slicedToArray(_ref, 2),
    tab = _ref2[0],
    setTab = _ref2[1];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.summaryContainer,
    id: "uploadCaseSetSummarySection"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: classes.summary,
    id: "uploadCaseSetSummaryCount"
  }, "".concat(matched.length + unmatched.length, " submitted Case IDs mapped to ").concat(matched.length, " unique Bento Case IDs")), error ? /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: (0, _clsx.default)(classes.summary, classes.error)
  }, error) : null, /*#__PURE__*/_react.default.createElement("p", {
    className: classes.title
  }, "Summary Table", /*#__PURE__*/_react.default.createElement(_ArrowRight.default, {
    className: classes.arrowRight
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.btnContainer
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: tab === 'matched' ? classes.summaryButton : classes.unselectedButton,
    onClick: function onClick() {
      return setTab('matched');
    },
    id: "uploadCaseSetMatched"
  }, /*#__PURE__*/_react.default.createElement("span", null, "Matched\xA0-\xA0"), /*#__PURE__*/_react.default.createElement("span", {
    id: "uploadCaseSetMatchedCount"
  }, matched.length)), /*#__PURE__*/_react.default.createElement("span", {
    className: tab === 'unmatched' ? classes.summaryButton : classes.unselectedButton,
    onClick: function onClick() {
      return setTab('unmatched');
    },
    id: "uploadCaseSetUnMatched"
  }, /*#__PURE__*/_react.default.createElement("span", null, "Unmatched\xA0-\xA0"), /*#__PURE__*/_react.default.createElement("span", {
    id: "uploadCaseSetUnMatchedCount"
  }, unmatched.length))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.tableBox
  }, tab === 'matched' ? matched.length ? /*#__PURE__*/_react.default.createElement("table", {
    className: classes.tableContainer,
    id: "uploadCaseSetMatchedTable"
  }, /*#__PURE__*/_react.default.createElement("tr", {
    id: "uploadCaseSetMatchedHeader"
  }, /*#__PURE__*/_react.default.createElement("th", {
    className: classes.header
  }, "SUBMITTED CASE ID"), /*#__PURE__*/_react.default.createElement("td", {
    className: classes.emptyCell
  }), /*#__PURE__*/_react.default.createElement("th", {
    className: classes.header
  }, "ASSOCIATED PROGRAM")), /*#__PURE__*/_react.default.createElement("tr", {
    className: classes.heading
  }, /*#__PURE__*/_react.default.createElement("td", {
    className: classes.columnPadding
  }, /*#__PURE__*/_react.default.createElement(_core.Divider, {
    style: {
      width: '100%'
    },
    className: classes.divider
  })), /*#__PURE__*/_react.default.createElement("td", {
    className: classes.emptyCell
  }), /*#__PURE__*/_react.default.createElement("td", {
    className: classes.dividerContainer
  }, /*#__PURE__*/_react.default.createElement(_core.Divider, {
    className: classes.divider
  }))), matched.map(function (data, id) {
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: id
    }, /*#__PURE__*/_react.default.createElement("td", {
      className: classes.tableColumn,
      style: id % 2 ? {
        backgroundColor: '#fff'
      } : {
        backgroundColor: '#F8F8F8'
      }
    }, data.subject_id), /*#__PURE__*/_react.default.createElement("td", {
      className: classes.emptyCell
    }), /*#__PURE__*/_react.default.createElement("td", {
      className: classes.programHeading,
      style: id % 2 ? {
        backgroundColor: '#fff'
      } : {
        backgroundColor: '#F8F8F8'
      }
    }, data.program_id));
  })) : null : unmatched.length ? /*#__PURE__*/_react.default.createElement("table", {
    className: classes.tableContainer,
    id: "uploadCaseSetUnMatchedTable"
  }, /*#__PURE__*/_react.default.createElement("th", {
    id: "uploadCaseSetUnMatchedHeader",
    className: classes.heading,
    style: {
      textAlign: 'left',
      paddingLeft: 50
    }
  }, "SUBMITTED CASE ID"), /*#__PURE__*/_react.default.createElement("tr", {
    className: classes.heading,
    style: {
      width: '180'
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Divider, {
    className: classes.divider,
    style: {
      width: '48%'
    }
  })), unmatched.map(function (data, id) {
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: id,
      style: id % 2 ? {
        backgroundColor: '#fff'
      } : {
        backgroundColor: '#F8F8F8'
      }
    }, /*#__PURE__*/_react.default.createElement("td", {
      className: classes.tableColumn,
      style: {
        textAlign: 'left',
        paddingLeft: 40
      }
    }, data));
  })) : null));
};

/**
 * Default styles for the component.
 */
var styles = function styles() {
  return {
    tableContainer: {
      border: '1px solid #c1c1c1',
      width: '-webkit-fill-available',
      backgroundColor: '#fff',
      padding: 14,
      marginBottom: 16
    },
    summaryButton: {
      fontSize: 12,
      fontWeight: 500,
      color: '#00387A',
      backgroundColor: '#fff',
      borderBottom: '4px solid #437bbe',
      cursor: 'pointer',
      padding: '11px 22px',
      fontFamily: 'Lato',
      textTransform: 'uppercase'
    },
    unselectedButton: {
      fontSize: 12,
      fontWeight: 500,
      color: '#00387A',
      backgroundColor: '#DEE0E2',
      cursor: 'pointer',
      padding: '11px 22px',
      fontFamily: 'Lato',
      textTransform: 'uppercase'
    },
    btnContainer: {
      marginBottom: 14
    },
    summary: {
      color: '#0D4A94',
      fontSize: 14,
      textAlign: 'center',
      margin: 0,
      paddingTop: 10,
      fontFamily: 'Lato',
      fontStyle: 'italic',
      fontWeight: 'bold'
    },
    title: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 300,
      color: '#000',
      fontSize: 16,
      fontFamily: 'Nunito'
    },
    arrowRight: {
      color: '#437BBE',
      fontSize: '2.5rem'
    },
    summaryContainer: {
      backgroundColor: '#CCD4DD',
      paddingLeft: 33,
      paddingRight: 33
    },
    heading: {
      fontSize: 12,
      color: '#437BBE',
      textAlign: 'center',
      paddingBottom: 10,
      fontFamily: 'lato',
      fontWeight: 100,
      letterSpacing: 0.5
    },
    header: {
      fontSize: 12,
      color: '#437BBE',
      textAlign: 'center',
      fontFamily: 'lato',
      paddingBottom: 10,
      fontWeight: 100,
      letterSpacing: 0.5
    },
    programHeading: {
      textAlign: 'center'
    },
    divider: {
      backgroundColor: '#93C0F5',
      width: '100%',
      height: 1
    },
    dividerContainer: {
      display: 'flex',
      justifyContent: 'center'
    },
    emptyCell: {
      width: 20
    },
    tableColumn: {
      color: '#0D8662',
      textAlign: 'center'
    },
    tableBox: {
      maxHeight: 150,
      overflowY: 'auto',
      maxWidth: '646px'
    },
    error: {
      color: 'red'
    }
  };
};
var _default = (0, _core.withStyles)(styles, {
  withTheme: true
})(SummaryTable);
exports.default = _default;